import axios from 'axios';

axios.defaults.withCredentials = true;

const localToken = localStorage.getItem('userToken');

if (localToken) {
	axios.defaults.headers.common = { Authorization: `Bearer ${localToken}` };
}

const baseURL = (() => {
	return 'https://wp.daitso.kbds.co.kr/wp-json';
})();

const defaultClient = axios.create({
	baseURL,
	withCredentials: true,
});

export default defaultClient;
